// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileImage_wrapper__zoDFD","image":"ProfileImage_image__1lp7K"};